import React, {useMemo} from 'react'
import Teaser from '../../components/cms/teaser'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/cms/module-container'
import Heading from '../../components/cms/heading'
import teaserListSlotRecipe from './index.recipe'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import {parseAspectRatio} from '../../utils/utils'

const TeaserList = ({
    background,
    anchor,
    headingLevel,
    heading,
    teaserList,
    imageRatio,
    teaserBackground
}) => {
    const recipe = useSlotRecipe({recipe: teaserListSlotRecipe})

    const isOneTeaser = useMemo(() => teaserList.length === 1, [teaserList])
    const styles = useMemo(() => recipe({isOneTeaser}), [recipe, isOneTeaser])

    return (
        <ModuleContainer
            anchor={anchor}
            background={background}
            css={styles.root}
            heading={heading}
        >
            <Heading
                {...heading}
                alignment={isOneTeaser ? 'left' : {base: 'left', s: 'center'}}
                headingLevel={headingLevel}
            ></Heading>

            <Box css={styles.teasersContainer}>
                {teaserList.map((teaser, index) => (
                    <Teaser
                        key={index}
                        {...teaser}
                        aspectRatio={parseAspectRatio(imageRatio)}
                        teaserBackground={teaserBackground}
                        widths={{
                            base: '87.5vw',
                            s: `${87.5 / Math.max(2, teaserList.length)}vw`,
                            l: 1680 / Math.max(2, teaserList.length)
                        }}
                    ></Teaser>
                ))}
            </Box>
        </ModuleContainer>
    )
}

TeaserList.propTypes = {
    anchor: PropTypes.string,
    background: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    teaserList: PropTypes.array,
    imageRatio: PropTypes.string,
    teaserBackground: PropTypes.bool
}

export default TeaserList
